import React from 'react';
import './bodytxt.css';

const Body = (props) => {
    return ( <>
        <p>{props.text}</p>
    </> );
}
 
export default Body;